import { transparentize } from 'polished';
import * as React from 'react';
import { InputHTMLAttributes } from 'react';
import styled, { css } from 'styled-components';

import theme from '../../easyclaim.app.theme/theme';
import { FadeIn } from '../animations/FadeIn';

import { Circle } from './Circle';
import { StyledIconCheck, StyledIconInvalid } from './CommonStyles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
	isValid?: boolean;
	isRequired: boolean;
	showInvalid?: boolean;
}

export class Input extends React.Component<InputProps, {}> {
	render() {
		const { isValid, ...props } = { ...this.props };

		return (
			<Container className="input-container">
				<TextInput {...props} />
				{this.props.isValid && (
					<BottomCircle
						size="2rem"
						borderColor={theme.colors.success}
						borderWidth="1px"
						borderStyle="solid"
					>
						<StyledIconCheck color={theme.colors.success} />
					</BottomCircle>
				)}
				{this.props.showInvalid &&
					((!this.props.isValid && this.props.value) ||
						(this.props.isRequired && !this.props.value)) && (
						<BottomCircle
							size="2rem"
							borderColor={theme.colors.danger}
							borderWidth="1px"
							borderStyle="solid"
						>
							<StyledIconInvalid color={theme.colors.danger} />
						</BottomCircle>
					)}
			</Container>
		);
	}
}

const Container = styled.div`
	position: relative;
	margin-bottom: 1rem;
`;

const TextInput = styled.input`
	color: #000;
	background-color: ${(p) => transparentize(0.7, p.theme.colors.secondary)};
	padding: 0.7rem 3.7rem 0.7rem 0.7rem;
	border-radius: 3px;
	width: calc(100% - 4.4rem);
	-moz-appearance: textfield;
	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	font-size: inherit;
	font-family: inherit;
	line-height: inherit;
	&::placeholder {
		color: rgba(0, 0, 0, 0.55);
		opacity: 1;
	}
`;

const BottomCircle = styled(Circle)`
	position: absolute;
	height: 2rem;
	top: 50%;
	margin-top: calc(-1rem - 1px);
	right: 1rem;
	animation: ${css`
			${FadeIn}`} 0.3s ease-in forwards;
`;
